export const toastDelayMs = 5000;
export const toastAnimDurationMs = 500;
export const toastHideDelayMs = toastDelayMs - toastAnimDurationMs;
